import { ReplyWithAttachmentSuggestion } from 'owa-mail-store';
import { action } from 'satcheljs';

export default action(
    'storeContextualMRUSuggestionsOnItemAction',
    (
        referenceItemId: string,
        contextualSuggestions: ReplyWithAttachmentSuggestion[],
        traceId: string
    ) => ({
        referenceItemId,
        contextualSuggestions,
        traceId,
    })
);
